import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const GifPlayer = makeShortcode("GifPlayer");
const Video = makeShortcode("Video");
const Aside = makeShortcode("Aside");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const ArtDirection = makeShortcode("ArtDirection");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Furniture can serve as another form of brand identity. Specialty elements, such as reception desks, can become focal points within interior architecture.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Custom furniture</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Design studies</AnchorLink>
    </AnchorLinks>
    <h2>{`Custom furniture`}</h2>
    <p>{`Consider the design of custom furniture within the context of IBM Design Language. The characteristics of duality can be expressed through a thoughtful contrast in materials. A rich metal juxtaposed with stone or wood reinforces a sense of tension between engineered and organic finishes. The 2x Grid anchors our design choices in proportional relationships. The intersection of different forms or volumes is informed by an underlying geometry.`}</p>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/7bdd60e5557f20bc541429245d6dac0b/furniture.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwABAv/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAWQ+BLI//8QAGBAAAwEBAAAAAAAAAAAAAAAAAhAREgH/2gAIAQEAAQUC1C0HXF//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAZEAABBQAAAAAAAAAAAAAAAAABABEgMUH/2gAIAQEABj8CpwtBj//EABkQAAMBAQEAAAAAAAAAAAAAAAABETEhUf/aAAgBAQABPyG+yRxixrwFGRgsP//aAAwDAQACAAMAAAAQaw//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxCn/8QAGxABAAIDAQEAAAAAAAAAAAAAAQARITFRkcH/2gAIAQEAAT8QLpJRDN9GYPgLnx+Mo3Ti4B2R0LB2CkAANE//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "custom reception desk",
              "title": "custom reception desk",
              "src": "/workplace-xg/static/7e01272a574d8acef30d339426b0da3b/2e753/custom-reception-desk.jpg",
              "srcSet": ["/workplace-xg/static/7e01272a574d8acef30d339426b0da3b/69549/custom-reception-desk.jpg 288w", "/workplace-xg/static/7e01272a574d8acef30d339426b0da3b/473e3/custom-reception-desk.jpg 576w", "/workplace-xg/static/7e01272a574d8acef30d339426b0da3b/2e753/custom-reception-desk.jpg 1152w", "/workplace-xg/static/7e01272a574d8acef30d339426b0da3b/74f4b/custom-reception-desk.jpg 1728w", "/workplace-xg/static/7e01272a574d8acef30d339426b0da3b/f35b7/custom-reception-desk.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <h2>{`Design studies`}</h2>
    <p>{`The design studies shown here are examples of how this design philosophy can be executed in a variety of solutions. Each scheme may be implemented in specific projects where appropriate or customized as needed. Additionally, we encourage our design teams to explore new concepts with these principles in mind.`}</p>
    <h3>{`Design study A`}</h3>
    <p>{`Our mainframes use a specially designed hexagonal grid pattern to ensure proper ventilation for the interiors of the systems. This mesh pattern provides a translucent finish that’s contrasted with a warm natural wood. Sheathed in a hexagonal screen, the natural wood finish is visible through the exterior shell. This juxtaposition is emblematic of the relationship between humanity and technology, the engineered and the organic.`}</p>
    <h4>{`Geometry`}</h4>
    <p>{`The proportions of the design are informed by the 2x Grid, creating a relationship between the perceived mass of both the wood and mesh forms. These proportions are modular in design and may be customized to meet the needs of any project. Depending on local requirements, some desks must provide a surface that’s an ADA-compliant height.`}</p>
    <h4>{`Finishes`}</h4>
    <p>{`A contrast in engineered and organic finishes is essential in this design concept. The mesh may be rendered in a variety of light or dark values. The wood base may also be executed in stone or concrete. Careful attention to details, joints and reveals will also reinforce a sense of precision.`}</p>
    <p>{`If you wish to implement this design concept within a project, contact IBM Global Real Estate and IBM Brand Experience and Design.`}</p>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/a8e83026ca85f52be7463095b184ab72/design-study-a.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHfDEDSwf/EABgQAAMBAQAAAAAAAAAAAAAAAAECEQAQ/9oACAEBAAEFAmsDAjjqLv/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAAMBAAAAAAAAAAAAAAAAAAEQICH/2gAIAQEABj8CyAv/xAAZEAEBAQADAAAAAAAAAAAAAAARARAAIUH/2gAIAQEAAT8hBQ8ZJZ5dYHbn/9oADAMBAAIAAwAAABAzD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABsQAQADAAMBAAAAAAAAAAAAAAEAESEQMWHB/9oACAEBAAE/EHuQdPIuAYCm39lPCaMVFMuHU//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "mesh and wood custom desk design study",
              "title": "mesh and wood custom desk design study",
              "src": "/workplace-xg/static/c80ac7976e52db6509b56f8436ec7ef5/2e753/mesh-and-wood-custom-desk-design-study.jpg",
              "srcSet": ["/workplace-xg/static/c80ac7976e52db6509b56f8436ec7ef5/69549/mesh-and-wood-custom-desk-design-study.jpg 288w", "/workplace-xg/static/c80ac7976e52db6509b56f8436ec7ef5/473e3/mesh-and-wood-custom-desk-design-study.jpg 576w", "/workplace-xg/static/c80ac7976e52db6509b56f8436ec7ef5/2e753/mesh-and-wood-custom-desk-design-study.jpg 1152w", "/workplace-xg/static/c80ac7976e52db6509b56f8436ec7ef5/a052a/mesh-and-wood-custom-desk-design-study.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  This design scheme is inspired by industrial finishes used in many IBM systems.
  </Aside>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
  
        <Tab label="Elevation" mdxType="Tab">
          <Row mdxType="Row">
            <Column mdxType="Column">
              <ArtDirection mdxType="ArtDirection">
                <img {...{
                  "src": "/workplace-xg/787ee863ffce65c119d198a9ef7b777d/mobile-design-study-elevation-a.svg",
                  "alt": "wood and mesh reception desk design elevation",
                  "title": "wood and mesh reception desk design elevation"
                }}></img>
                <img {...{
                  "src": "/workplace-xg/15ffb576f1d5f270cbe81a3ea9a10c47/desktop-design-study-elevation-a.svg",
                  "alt": "wood and mesh reception desk design elevation",
                  "title": "wood and mesh reception desk design elevation"
                }}></img>
              </ArtDirection>
            </Column>
          </Row>  
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <Row mdxType="Row">
            <Column mdxType="Column">
              <ArtDirection mdxType="ArtDirection">
                <img {...{
                  "src": "/workplace-xg/26718eec3cfec16c1ef42dbb6aad501c/mobile-design-study-plan-a.svg",
                  "alt": "wood and mesh reception desk design plan",
                  "title": "wood and mesh reception desk design plan"
                }}></img>
                <img {...{
                  "src": "/workplace-xg/1202de72c331d2f7293616b7007f3a92/desktop-design-study-plan-a.svg",
                  "alt": "wood and mesh reception desk design plan",
                  "title": "wood and mesh reception desk design plan"
                }}></img>
              </ArtDirection>
            </Column>
          </Row>  
        </Tab>
      </Tabs>
    </div>
    <h3>{`Design study B`}</h3>
    <p>{`Two L-shaped forms intersect to make this light and inviting desk design. Less imposing than most volumetric approaches, this concept relies on carefully engineered planes kept as thin as possible to emphasize the simple forms and keep the desk visually light and open. Use of contrasting color and material provide interesting tension while referencing the relationship between humanity and technology, the engineered and the organic.`}</p>
    <h4>{`Geometry`}</h4>
    <p>{`The proportions of the design are informed by the 2x Grid, creating a balance between the two intersecting planar surfaces. These proportions are modular in design and may be customized to meet the needs of any project. Depending on local requirements, some desks must provide a surface that’s an ADA-compliant height.`}</p>
    <h4>{`Finishes`}</h4>
    <p>{`The use of two materials, one organic and the other man-made, contrast each other but their apparent mass must be scaled to balance each other. Various wood species and colors may be used but should always contrast the intersecting plane of man-made material. Swapping which plane is the organic and which one is the engineered material is also an option.`}</p>
    <p>{`If you wish to implement this design concept within a project, contact IBM Global Real Estate and IBM Brand Experience and Design.`}</p>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/68d657a1c5af0c46f84b5854828a9008/design-study-b.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHdZlhiRX//xAAaEAACAgMAAAAAAAAAAAAAAAAAAQIDEBES/9oACAEBAAEFAlHgUmKzaz//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAYEAACAwAAAAAAAAAAAAAAAAAAESAhMf/aAAgBAQAGPwKjBqH/xAAcEAACAQUBAAAAAAAAAAAAAAAAASEQETFRgbH/2gAIAQEAAT8hgejWPohFyVRowf/aAAwDAQACAAMAAAAQi8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhQTFRccH/2gAIAQEAAT8QDBv1Mta3VfkFwUNXNQnRKMAoOAn/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Metal and wood reception desk design study",
              "title": "Metal and wood reception desk design study",
              "src": "/workplace-xg/static/1f1f7c0deb52c6b1241b0e35e7abad75/2e753/metal-and-wood-reception-desk-design-study.jpg",
              "srcSet": ["/workplace-xg/static/1f1f7c0deb52c6b1241b0e35e7abad75/69549/metal-and-wood-reception-desk-design-study.jpg 288w", "/workplace-xg/static/1f1f7c0deb52c6b1241b0e35e7abad75/473e3/metal-and-wood-reception-desk-design-study.jpg 576w", "/workplace-xg/static/1f1f7c0deb52c6b1241b0e35e7abad75/2e753/metal-and-wood-reception-desk-design-study.jpg 1152w", "/workplace-xg/static/1f1f7c0deb52c6b1241b0e35e7abad75/74f4b/metal-and-wood-reception-desk-design-study.jpg 1728w", "/workplace-xg/static/1f1f7c0deb52c6b1241b0e35e7abad75/f35b7/metal-and-wood-reception-desk-design-study.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  Simplicity and openness are the concepts of this design.
  </Aside>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <Row mdxType="Row">
            <Column mdxType="Column">
              <ArtDirection mdxType="ArtDirection">
                <img {...{
                  "src": "/workplace-xg/a5151557d995689abb76992470179b12/mobile-design-study-elevation-b.svg",
                  "alt": "metal and wood reception desk design elevation",
                  "title": "metal and wood reception desk design elevation"
                }}></img>
                <img {...{
                  "src": "/workplace-xg/0de25fba541abb101029c37a859ea234/desktop-design-study-elevation-b.svg",
                  "alt": "metal and wood reception desk design elevation",
                  "title": "metal and wood reception desk design elevation"
                }}></img>
              </ArtDirection>
            </Column>
          </Row>  
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <Row mdxType="Row">
            <Column mdxType="Column">
              <ArtDirection mdxType="ArtDirection">
                <img {...{
                  "src": "/workplace-xg/4a68651b565ffc0d44c3d58e107e336d/mobile-design-study-plan-b.svg",
                  "alt": "metal and wood reception desk design plan",
                  "title": "metal and wood reception desk design plan"
                }}></img>
                <img {...{
                  "src": "/workplace-xg/b1ef0027ccd6454e18019348d352ee62/desktop-design-study-plan-b.svg",
                  "alt": "metal and wood reception desk design plan",
                  "title": "metal and wood reception desk design plan"
                }}></img>
              </ArtDirection>
            </Column>
          </Row>  
        </Tab>
      </Tabs>
    </div>
    <h3>{`Design study C`}</h3>
    <p>{`A blue glass is used in this design to reference IBM “blue.” The 8 layers of glass create a functional ADA-compliant surface, and provide a connection to the 8 bars that form the IBM 8-bar logo. The light, translucent man-made material contrasts with the solid stone mass of the main desk and illustrates the duality of man and machine. Together, these metaphors provide an unexpected visual for the arrival of the IBM guest.`}</p>
    <h4>{`Geometry`}</h4>
    <p>{`The proportions of the design are informed by the 2x Grid, creating a relationship between thin, but colorful, glass and the mass of the stone. These proportions are modular in design and may be customized to meet the needs of any project. Depending on local requirements, some desks must provide a surface that’s an ADA-compliant height.`}</p>
    <h4>{`Finishes`}</h4>
    <p>{`Use of blue material rather than a painted surface creates a rich and authentic application of this important color. Other materials, such as anodized aluminum, can also be substituted. The stone surface could also be constructed of man-made material like concrete and a stained wood used in place of the glass.`}</p>
    <Row className="mt-32" mdxType="Row">
      <Column colLg={8} colMd={5} mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/efe828e753492783c4fd50d7668d9863/design-study-c.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.90277777777778%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwACBP/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAexiyPHH/8QAGRABAAIDAAAAAAAAAAAAAAAAAgABAxAR/9oACAEBAAEFAnlIhVXXYt//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAZEAABBQAAAAAAAAAAAAAAAAAAESAhIoH/2gAIAQEABj8CsLOt/8QAGhAAAwADAQAAAAAAAAAAAAAAAAERITFRgf/aAAgBAQABPyFlGnhD0i6spD0JgWdiP//aAAwDAQACAAMAAAAQqM//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAgEBPxCH/8QAGhABAQEBAQEBAAAAAAAAAAAAAREAIVExcf/aAAgBAQABPxAOlJYVzeYJ4L0PP3XKuYmUuTNLPlcCb//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "reception desk design study",
              "title": "reception desk design study",
              "src": "/workplace-xg/static/ca1d694953ac3c481e04c83185056119/2e753/reception-desk-design-study.jpg",
              "srcSet": ["/workplace-xg/static/ca1d694953ac3c481e04c83185056119/69549/reception-desk-design-study.jpg 288w", "/workplace-xg/static/ca1d694953ac3c481e04c83185056119/473e3/reception-desk-design-study.jpg 576w", "/workplace-xg/static/ca1d694953ac3c481e04c83185056119/2e753/reception-desk-design-study.jpg 1152w", "/workplace-xg/static/ca1d694953ac3c481e04c83185056119/efa0b/reception-desk-design-study.jpg 1214w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
      <Column colLg={3} colMd={2} offsetMd={1} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
  Use material color and shape as a reference to the IBM logo.
  </Aside>
      </Column>
    </Row>
    <div className="tabs-no-padding">
      <Tabs mdxType="Tabs">
        <Tab label="Elevation" mdxType="Tab">
          <Row mdxType="Row">
            <Column mdxType="Column">
              <ArtDirection mdxType="ArtDirection">
                <img {...{
                  "src": "/workplace-xg/585407a8467feb59ea46ae29335868e7/mobile-design-study-elevation-c.svg",
                  "alt": "reception desk design elevation",
                  "title": "reception desk design elevation"
                }}></img>
                <img {...{
                  "src": "/workplace-xg/25c6f0e795f286223ebe7977cbd2c874/desktop-design-study-elevation-c.svg",
                  "alt": "reception desk design elevation",
                  "title": "reception desk design elevation"
                }}></img>
              </ArtDirection>
            </Column>
          </Row>  
        </Tab>
        <Tab label="Plan" mdxType="Tab">
          <Row mdxType="Row">
            <Column mdxType="Column">
              <ArtDirection mdxType="ArtDirection">
                <img {...{
                  "src": "/workplace-xg/b7b9270f8b67a99679a9b496ae60f0cf/mobile-design-study-plan-c.svg",
                  "alt": "reception desk design plan",
                  "title": "reception desk design plan"
                }}></img>
                <img {...{
                  "src": "/workplace-xg/8bb1909729b58f2d1998019e3383ca5c/desktop-design-study-plan-c.svg",
                  "alt": "reception desk design plan",
                  "title": "reception desk design plan"
                }}></img>
              </ArtDirection>
            </Column>
          </Row>  
        </Tab>
      </Tabs>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      